import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Icon,
    Row,
    Col,
    Modal,
    ModalBody,
    ModalHeader
} from 'design-react-kit';
import { SchedaPersonaAfferenza, getUserFoto } from 'uniba-volto-persone/components';
import qrcodeSVG from '../../../theme/images/qr_code.svg';
import vcardSVG from '../../../theme/images/vcard.svg';
import { getPersonaOgg, getPersonaQRCode } from 'uniba-volto-persone/actions';
import { getBlobFromBase64, copyToClipboard, ClipboardButton } from 'design-comuni-plone-theme/components';
import { NavLink } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu } from 'semantic-ui-react';
import formatPhoneNumbers from '../../Common/formatPhoneNumbers';
import orgchart_png from '../../../theme/images/orgchart-icon.png'
import { Helmet } from '@plone/volto/helpers';

class SchedaPersonaSimpleView extends Component {
    constructor(props) {
        super(props);

        let contentProps = props.props;
        const isFullObject = contentProps.content !== undefined;
        const isViewlet = contentProps?.viewlet;
        if (isFullObject) {
            contentProps = contentProps.content;
        }

        const username = isFullObject ? contentProps.id : contentProps.getId;
        const api_endpoint = `/rubrica/${username}`;

        const { foto: foto, placeholder: isDefault } = getUserFoto(contentProps, isFullObject);
        this.state = {
            props: contentProps,
            telefoniResult: isFullObject ? contentProps.telefono : contentProps['getTelefono'],
            telefoniRespResult: contentProps.getTelefonoResp,
            faxResult: isFullObject ? contentProps.fax : { items: [] },
            noteResult: isFullObject ? contentProps.indirizzo?.data : contentProps['getNote'],
            mailResult: contentProps.email,
            username,
            api_endpoint,
            finalUserFoto: foto,
            additionalRowClassNames: isFullObject ? (isViewlet ? 'mt-2' : 'container ms-auto me-auto mt-2') : 'mt-2',
            viewLink: `/rubrica/${username}`,
            etichetta_ruolo: isFullObject ? contentProps?.ruolo_gender?.title : contentProps?.getRuoloGender,
            show_link_generator: isFullObject,
            imageSrc: foto,
            imageOverride: false,
            opacity: 1,
            isTransitioning: false,
            isOpenLinkGenerator: false,
            linkValue: '',
            linkTemplate: 'default',
            linkShowAsLink: 'no',
            linkStyle: 'default',
            linkCompact: 'no',
            enableOrganigramma: false,
            review_state: contentProps?.review_state,
        };
        this._timeouts = [];
        this._isMounted = false;
    };

    setSafeTimeout(fn, delay) {
        const id = setTimeout(fn, delay);
        this._timeouts.push(id);
    }

    updateLinkValue() {
        const {
            username,
            linkTemplate,
            linkShowAsLink,
            linkStyle,
            linkCompact
        } = this.state;
        const baseLink = "https://persone.ict.uniba.it/rubrica/";
        let link = baseLink + username + '/json';
        const params = [];

        if (linkTemplate !== "default") params.push(`template=${linkTemplate}`);
        if (linkShowAsLink !== "no") params.push('showText=1');
        if (linkStyle !== "default") params.push(`style=${linkStyle}`);
        if (linkCompact !== "no") params.push('compact=1');

        if (params.length > 0) link += '?' + params.join('&');
        const embeddable = `<a class="external-link" href="${link}">${this.state.props.title}</a>`;

        this.setState({ linkValue: embeddable });
    };

    getFetchedImageSrc() {
        const { personaQRCodeReducer } = this.props;
        const { api_endpoint } = this.state;

        const image64 = personaQRCodeReducer.items?.[api_endpoint];
        if (!image64) return null;

        const imageBlob = getBlobFromBase64(image64);
        if (!imageBlob) return null;

        const imageUrl = URL.createObjectURL(imageBlob);
        return imageUrl;
    };

    handleClick = () => {
        const { imageOverride, finalUserFoto, isTransitioning } = this.state;
        const { personaQRCodeReducer } = this.props;

        if (isTransitioning) return;

        const image64 = personaQRCodeReducer.items[this.state.api_endpoint];
        if (!image64) return;

        const imageBlob = getBlobFromBase64(image64);
        if (!imageBlob) return;

        const fetchedImageSrc = URL.createObjectURL(imageBlob);

        this.setState({ isTransitioning: true, opacity: 0 }, () => {
            this.setSafeTimeout(() => {
                if (!this._isMounted) return;
                this.setState({
                    imageSrc: imageOverride ? finalUserFoto : fetchedImageSrc,
                    imageOverride: !imageOverride
                }, () => {
                    this.setSafeTimeout(() => {
                        if (!this._isMounted) return;
                        this.setState({ opacity: 1, isTransitioning: false });
                    }, 50);
                });
            }, 300);
        });
    };

    componentDidMount() {
        this._isMounted = true;
        const { api_endpoint } = this.state;
        this.props.getPersonaOgg(api_endpoint);
        this.props.getPersonaQRCode(api_endpoint);
        this.updateLinkValue();
    };

    componentDidUpdate(prevProps, prevState) {
        const keys = ['linkTemplate', 'linkShowAsLink', 'linkStyle', 'linkCompact'];
        if (keys.some(k => prevState[k] !== this.state[k])) {
            this.updateLinkValue();
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
        this._timeouts.forEach(clearTimeout);
        this._timeouts = [];
    };

    render() {
        const {
            intl,
            showViewLink,
            onClose,
            userSession,
            history,
            userResult,
            toastify,
            location
        } = this.props;

        const {
            username,
            imageSrc,
            api_endpoint,
            props,
            imageOverride,
            opacity,
            viewLink,
            etichetta_ruolo,
            telefoniResult,
            faxResult,
            mailResult,
            noteResult,
            show_link_generator,
            isOpenLinkGenerator,
            linkValue,
            linkTemplate,
            linkShowAsLink,
            linkStyle,
            linkCompact,
            enableOrganigramma,
            review_state,
            telefoniRespResult
        } = this.state;

        const {
            sede: sedeResult,
            ruolo: ruoloResult,
            datiPrivati: datiPrivatiResult,
            paginaWeb: paginawebResult,
        } = this.props.personaOggReducer.items?.[api_endpoint] || {};

        const fullName = props.title;

        const vcardTitle = intl.formatMessage({ id: 'btnVcardTitle' });
        const qrcodeTitle = intl.formatMessage({ id: 'btnQrcodeTitle' });
        const editTitle = intl.formatMessage({ id: 'modificaSchedaPersonaTitle' });
        const aggiuntiviTitle = intl.formatMessage({ id: 'mostraAggiuntiviTitle' });
        const embedTitle = intl.formatMessage({ id: 'embedTitle' });
        const embedModalTitle = intl.formatMessage({ id: 'embedModalTitle' });
        const intl_si = intl.formatMessage({ id: 'feedback_form_yes' });
        const intl_no = intl.formatMessage({ id: 'feedback_form_no' });
        const intl_faxPrincipale = intl.formatMessage({ id: 'faxPrincipale' });
        const intl_telefonoPrincipale = intl.formatMessage({ id: 'telefonoPrincipale' });
        const intl_warningLabel = intl.formatMessage({ id: 'warningLabel' });
        const intl_warningIncompleteLabel = intl.formatMessage({ id: 'warningIncompleteLabel' });
        const intl_warningPrivateLabel = intl.formatMessage({ id: 'warningPrivateLabel' });
        const intl_warningAspettativaLabel = intl.formatMessage({ id: 'warningAspettativaLabel' });


        const finalUserFotoAlt = intl.formatMessage(
            { id: 'schedaPersonaFotoAlt' },
            { fullName: fullName }
        );

        const renderAfferenza = <SchedaPersonaAfferenza path={api_endpoint} />
        const pulsanteDatiAggiuntivi =
            <Button color='white'
                className="d-flex flex-column align-items-center btn-icontext btn-outline-primary"
                title={aggiuntiviTitle}
                aria-label={aggiuntiviTitle}
            >
                <Icon icon="it-more-actions" color="primary" aria-hidden="true" />
                {intl.formatMessage({ id: 'mostraAggiuntivi' })}
            </Button>;


        const isAnon = userSession.token == null;

        const vcard_endpoint = "@getVCard";
        const vcard_url_api = `/++api++/rubrica/${username}/${vcard_endpoint}`;

        const fetchedImageSrc = this.getFetchedImageSrc();
        const queryString = location.search;

        const REVIEW_STATE_LABELS = {
            fixed: 'Fisso Pubblico',
            fixedPrivate: 'Fisso Privato',
            aspettativa: 'Aspettativa',
            incompleto: 'Incompleta',
            private: 'Nascosto',
            published: 'Pubblicato',
        };
        const review_state_label =
            !['fixed', 'published'].includes(review_state)
                ? REVIEW_STATE_LABELS[review_state]
                : null;
        const fullNameWithState = review_state_label
            ? `${fullName} (${review_state_label})`
            : fullName;

        return (
            <>
                <Helmet>
                    <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                {review_state === 'incompleto' ? (
                    <div className="alert alert-warning mt-2" role="alert">
                        <b>{intl_warningLabel}:</b> {intl_warningIncompleteLabel}.
                    </div>
                ) : (review_state === 'private' || review_state === 'fixedPrivate') ? (
                    <div className="alert alert-danger mt-2" role="alert">
                        <b>{intl_warningLabel}:</b> {intl_warningPrivateLabel}.
                    </div>
                ) : (review_state === 'aspettativa') ? (
                    <div className="alert alert-info mt-2" role="alert">
                        <b>{intl_warningLabel}:</b> {intl_warningAspettativaLabel}.
                    </div>
                ) : null}
                <div className="row-scheda">
                    <div
                        className="col-scheda-img p-0"
                    >
                        <Card className="card-img no-after shadow rounded">
                            <img
                                alt={finalUserFotoAlt}
                                src={imageSrc}
                                title={finalUserFotoAlt}
                                className={
                                    "img-fluid immagine-profilo-scheda rounded-top" +
                                    (imageOverride ? " qrcode" : "")
                                }
                                style={{ opacity: opacity, }}
                            />
                            <CardBody
                                className='p-2 rounded-bottom d-flex 
                                    flex-column align-items-center 
                                    justify-content-center'
                            >
                                {(viewLink && showViewLink) ? (
                                    <NavLink
                                        className="text-decoration-none stretched-link d-block d-sm-none"
                                        to={`${viewLink}${queryString}`}
                                        key={viewLink}
                                        onClick={() => { onClose?.(); }}
                                    >
                                        <h2 className='text-center sp-nome-completo fs-1 mb-0'>
                                            {fullNameWithState}
                                        </h2>
                                    </NavLink>
                                ) : (
                                    <h2 className='text-center sp-nome-completo d-block d-sm-none'>
                                        {fullNameWithState}
                                    </h2>
                                )}
                                {(etichetta_ruolo && etichetta_ruolo.trim() !== '') ? (
                                    <h4 className='text-center sp-ruolo mb-0 fs-3'>
                                        {etichetta_ruolo}
                                    </h4>
                                ) : (ruoloResult !== 'null' ? (
                                    <h4 className='text-center sp-ruolo'>
                                        {ruoloResult}
                                    </h4>
                                ) : null)}
                            </CardBody>
                        </Card>
                    </div>
                    <div
                        className='col-scheda-info p-0'
                    >
                        <div className='info-box ps-3'>
                            {(viewLink && showViewLink) ? (
                                <NavLink
                                    className="text-decoration-none d-none d-sm-block"
                                    to={`${viewLink}${queryString}`}
                                    key={viewLink}
                                    onClick={() => { onClose?.(); }}
                                >
                                    <h2 className='sp-nome-completo fs-0 mb-0'>
                                        {fullNameWithState}
                                    </h2>
                                </NavLink>
                            ) : (
                                <h2 className='sp-nome-completo fs-0 d-none d-sm-block'>
                                    {fullNameWithState}
                                </h2>
                            )}
                            <div className="afferenze">
                                <h2 className='d-inline-block me-3'>
                                    {intl.formatMessage(
                                        { id: 'schedaPersonaAssegnazione' }
                                    )}
                                </h2>
                                {(!isAnon && enableOrganigramma) ? (
                                    <Button color='white'
                                        onClick={() => {
                                            onClose?.();
                                            const afferenzaElement = document.getElementById('afferenza-utente');
                                            if (afferenzaElement) {
                                                const linkElement = afferenzaElement.querySelector('a');
                                                if (linkElement) {
                                                    const href = linkElement.getAttribute('href');
                                                    if (href) {
                                                        const newUrl = href.includes('?')
                                                            ? `${href}&organigramma`
                                                            : `${href}?organigramma`;
                                                        history.push(newUrl);
                                                    }
                                                }
                                            }
                                        }}
                                        className="d-inline-flex btn-icontext 
                                            btn-outline-primary btn btn-white
                                            flex-row align-items-center"
                                        title={intl.formatMessage(
                                            { id: 'organigrammaTitle' }
                                        )}
                                    >
                                        <img
                                            className="me-1"
                                            width={16}
                                            height={16}
                                            src={orgchart_png}
                                            aria-hidden="true"
                                        />
                                        {
                                            intl.formatMessage(
                                                { id: 'organigramma' }
                                            )
                                        }
                                    </Button>
                                ) : null}
                                {renderAfferenza}
                            </div>
                            <div className="informazioni mb-2">
                                <h2>Info</h2>
                                {telefoniResult?.items?.map((telefono, index) => (
                                    <div key={index}>
                                        <p className="telefono d-flex flew-row align-items-center" >
                                            <Icon className="me-2" icon="it-telephone" />
                                            <a href={`tel:${formatPhoneNumbers(telefono.telefono)}`}>{formatPhoneNumbers(telefono.telefono)}</a>
                                            <>
                                                <span className='ms-2'>{telefono.interno && ` int. ${telefono.interno}`}</span>
                                            </>
                                            {telefono.indicazioni && (
                                                <>
                                                    <span className='ms-2'>- <b>{telefono.indicazioni}</b></span>
                                                </>
                                            )}
                                            {telefono.principale &&
                                                <Icon
                                                    aria-label={intl_telefonoPrincipale}
                                                    title={intl_telefonoPrincipale}
                                                    icon="it-bookmark"
                                                    color="success"
                                                    size="sm"
                                                />
                                            }
                                        </p>
                                    </div>
                                ))}
                                {telefoniResult?.items?.length == 0 &&
                                    telefoniRespResult &&
                                    Object.values(telefoniRespResult)?.[0]?.items?.map((telefono, index) => (
                                        <div key={index}>
                                            <p className="telefono d-flex flew-row align-items-center" >
                                                <Icon className="me-2" icon="it-telephone" />
                                                <a href={`tel:${formatPhoneNumbers(telefono.telefono)}`}>{formatPhoneNumbers(telefono.telefono)}</a>
                                                <>
                                                    <span className='ms-2'>{telefono.interno && ` int. ${telefono.interno}`}</span>
                                                </>
                                                {telefono.indicazioni && (
                                                    <>
                                                        <span className='ms-2'>- <b>{telefono.indicazioni}</b>
                                                            {" "}
                                                            (recapito del{" "}
                                                            <NavLink to={`/rubrica/${Object.keys(telefoniRespResult)[0]}`}>
                                                                responsabile
                                                            </NavLink>)
                                                        </span>
                                                    </>
                                                )}
                                                {telefono.principale &&
                                                    <Icon
                                                        aria-label={intl_telefonoPrincipale}
                                                        title={intl_telefonoPrincipale}
                                                        icon="it-bookmark"
                                                        color="success"
                                                        size="sm"
                                                    />
                                                }
                                            </p>
                                        </div>
                                    ))
                                }
                                {/* MOSTRO L'AVVISO DI RIFERIMENTO TELEFONICO MANCANTE */}
                                {!isAnon &&
                                    telefoniResult?.items?.length == 0 &&
                                    (userResult.username == username || userResult.roles?.includes("Manager")) ?
                                    (
                                        <div className="alert alert-warning" role="alert">
                                            {
                                                intl.formatMessage(
                                                    { id: 'warn_telefono_da_definire' }
                                                )
                                            }
                                        </div>
                                    )
                                    :
                                    null
                                }
                                {faxResult?.items?.map((fax, index) => (
                                    <div key={index}>
                                        <p className="fax d-flex flew-row align-items-center">
                                            <Icon className="me-2" icon="it-print" />
                                            <a href={`tel:${fax.fax}`}>{fax.fax}</a>
                                            <>
                                                <span className='ms-2'>
                                                    {fax.interno && ` int. ${fax.interno}`}
                                                </span>
                                            </>
                                            {fax.indicazioni && (
                                                <>
                                                    <span className='ms-2'>- <b>{fax.indicazioni}</b></span>
                                                </>
                                            )}
                                            {fax.principale &&
                                                <Icon
                                                    aria-label={intl_faxPrincipale}
                                                    title={intl_faxPrincipale}
                                                    icon="it-bookmark"
                                                    color="success"
                                                    size="sm"
                                                />
                                            }
                                        </p>
                                    </div>
                                ))}
                                {mailResult ? (
                                    <div className="email">
                                        <p className="d-flex flew-row align-items-center">
                                            <Icon className="me-2" icon="it-mail" />
                                            <a href={`mailto:${mailResult}`}>
                                                {mailResult}
                                            </a>
                                        </p>
                                    </div>
                                ) : null}
                                {sedeResult && Object.keys(sedeResult).length > 0 ?
                                    (
                                        <div>
                                            <p className="sede">
                                                <Icon className="me-2" icon="it-map-marker-circle" />
                                                <a href={`http://maps.google.com/?q=${sedeResult?.title}`} target="_blank">
                                                    {sedeResult?.title}
                                                </a>
                                            </p>
                                        </div>
                                    )
                                    :
                                    (
                                        <div className="alert alert-warning" role="alert">
                                            {
                                                intl.formatMessage(
                                                    { id: 'warn_sede_da_definire' }
                                                )
                                            }
                                        </div>
                                    )
                                }
                                {paginawebResult ? (
                                    <div>
                                        <p className="sitoweb">
                                            <Icon className="me-2" icon="it-pa" />
                                            <a href={paginawebResult} target="_blank" rel="noopener noreferrer">
                                                {paginawebResult}
                                            </a>
                                        </p>
                                    </div>
                                ) : null}
                                {(noteResult && noteResult.length <= 1000) ? (
                                    <div>
                                        <h2 className="mt-2">Note</h2>
                                        <p
                                            className="note-text"
                                            dangerouslySetInnerHTML={
                                                { __html: noteResult }
                                            }
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div
                            className='scheda-buttons-box d-flex flex-row 
                                align-items-center justify-content-start ms-3'
                        >
                            {/* MOSTRO IL PULSANTE CHE MOSTRA ALTRI DATI */}
                            {
                                !isAnon &&
                                    datiPrivatiResult &&
                                    api_endpoint &&
                                    typeof datiPrivatiResult === 'object' &&
                                    Object.entries(datiPrivatiResult).length > 0 ? (
                                    <Dropdown trigger={pulsanteDatiAggiuntivi} icon={<></>}>
                                        <DropdownMenu>
                                            {Object.entries(datiPrivatiResult).map(
                                                ([key, value]) => {
                                                    if (key === "Aliases") {
                                                        return (
                                                            <DropdownItem key={key}>
                                                                <b>{key}</b>
                                                                <br />
                                                                {Object.entries(value).map(([aliasName, aliasHref]) => (
                                                                    <div key={aliasName}>
                                                                        <a href={aliasHref + "/json"} target="_blank" rel="noopener noreferrer">
                                                                            {aliasName}
                                                                        </a>
                                                                        <br />
                                                                    </div>
                                                                ))}
                                                            </DropdownItem>
                                                        );
                                                    }
                                                    const messageKey = key + "Alt";
                                                    var message = intl.formatMessage({ id: messageKey });
                                                    if (message == messageKey) {
                                                        console.warn(`Messaggio non trovato per la chiave: ${messageKey}`);
                                                        message = key;
                                                    }
                                                    return (
                                                        <DropdownItem
                                                            key={key}
                                                            onClick={async () => {
                                                                try {
                                                                    const result = await copyToClipboard(value);
                                                                    const cleanedMessage = message.replace(' (dato privato):', '');
                                                                    if (result.success) {
                                                                        toastify.toast.success(`${cleanedMessage} copiato con successo!`, { autoClose: 2000 });
                                                                    } else {
                                                                        toastify.toast.error(`Errore durante la copia: ${result.error}`, { autoClose: 2000 });
                                                                    }
                                                                } catch (error) {
                                                                    toastify.toast.error(`Errore sconosciuto durante la copia: ${error}`, { autoClose: 2000 });
                                                                }
                                                            }}
                                                        >
                                                            <b>{message}</b>
                                                            <br />
                                                            {value}
                                                            <Icon
                                                                icon="it-copy"
                                                                color="primary"
                                                                aria-hidden="true"
                                                                size="xs"
                                                            />
                                                        </DropdownItem>
                                                    );
                                                })
                                            }
                                        </DropdownMenu>
                                    </Dropdown>
                                ) : null}
                            {/* MOSTRO IL PULSANTE DI MODIFICA DELLA SCHEDA */}
                            {!isAnon && (userResult.username == username || userResult.roles?.includes("Manager")) ? (
                                <Button color='white'
                                    onClick={() => {
                                        onClose?.();
                                        history.push((viewLink ? viewLink : username) + '/edit');
                                    }}
                                    className="d-inline-flex flex-column 
                                        align-items-center btn-icontext 
                                        btn-outline-primary"
                                    title={editTitle}
                                    aria-label={editTitle}
                                >
                                    <Icon icon="it-pencil" color="primary" aria-hidden="true" />
                                    {intl.formatMessage({ id: 'modificaSchedaPersona' })}
                                </Button>
                            ) : null}
                            {/* MOSTRO IL PULSANTE PER GENERARE IL LINK */}
                            {!isAnon ? (
                                <Button color='white'
                                    onClick={async () => {
                                        if (show_link_generator) {
                                            this.setState((prevState) => ({
                                                isOpenLinkGenerator: !prevState.isOpenLinkGenerator,
                                            }));
                                        } else {
                                            try {
                                                const result = await copyToClipboard(linkValue);
                                                if (result.success) {
                                                    toastify.toast.success("Link copiato con successo!", { autoClose: 2000 });
                                                } else {
                                                    toastify.toast.error(`Errore durante la copia: ${result.error}`, { autoClose: 2000 });
                                                }
                                            } catch (error) {
                                                toastify.toast.error(`Errore sconosciuto durante la copia: ${error}`, { autoClose: 2000 });
                                            }
                                        }
                                    }}
                                    className="d-inline-flex flex-column align-items-center btn-icontext btn-outline-primary"
                                    title={show_link_generator ? embedModalTitle : embedTitle}
                                    aria-label={show_link_generator ? embedModalTitle : embedTitle}
                                >
                                    <Icon
                                        icon="it-code-circle"
                                        color="primary"
                                        aria-hidden="true"
                                    />
                                    {
                                        show_link_generator ?
                                            intl.formatMessage({ id: 'embedModal' }) :
                                            intl.formatMessage({ id: 'embed' })
                                    }
                                </Button>
                            ) : null}
                            {!isAnon ? (
                                <div
                                    className='scheda-buttons-box-separator'
                                />
                            ) : null}
                            <Button
                                color='white'
                                onClick={() => { window.location.href = vcard_url_api }}
                                className="d-inline-flex flex-column align-items-center btn-icontext btn-outline-primary"
                                title={vcardTitle}
                                aria-label={vcardTitle}
                            >
                                <Icon src={vcardSVG} title={vcardTitle} aria-hidden="true" />
                                {intl.formatMessage({ id: 'btnVcard' })}
                            </Button>
                            {/* MOSTRO IL PULSANTE DI MOSTRA/NASCONDI QR CODE */}
                            {fetchedImageSrc ? (
                                <Button
                                    color='white'
                                    onClick={this.handleClick}
                                    className="d-inline-flex flex-column align-items-center btn-icontext btn-outline-primary"
                                    title={qrcodeTitle}
                                    aria-label={qrcodeTitle}
                                >
                                    <Icon src={qrcodeSVG} title={qrcodeTitle} aria-hidden="true" />
                                    {intl.formatMessage({ id: !imageOverride ? 'btnQrcodeShow' : 'btnQrcodeHide' })}
                                </Button>
                            ) : null}
                        </div>
                        {/* MOSTRO I CAMPI PER GENERARE IL LINK */}
                        {(!isAnon && show_link_generator) ? (
                            <Modal
                                isOpen={isOpenLinkGenerator}
                                toggle={() => {
                                    this.setState((prevState) => ({
                                        isOpenLinkGenerator: !prevState.isOpenLinkGenerator,
                                    }));
                                }}
                                size="lg"
                            >
                                <ModalHeader toggle={() => {
                                    this.setState((prevState) => ({
                                        isOpenLinkGenerator: !prevState.isOpenLinkGenerator,
                                    }));
                                }} />
                                <ModalBody className='pt-0'>
                                    <Card id="genLinkCard">
                                        <CardBody className='p-1'>
                                            <CardTitle tag="h1">
                                                {intl.formatMessage({ id: 'embedModal' })}
                                            </CardTitle>
                                            <div>
                                                <label className='me-2'>{intl.formatMessage({ id: 'embedModalTemplate' })}</label>
                                                <div className="select-wrapper">
                                                    <select
                                                        id="template"
                                                        value={linkTemplate}
                                                        onChange={(e) => this.setState({ linkTemplate: e.target.value })}
                                                    >
                                                        <option value="default">Default</option>
                                                        <option value="username">username</option>
                                                        <option value="docente">docente</option>
                                                    </select>
                                                </div>
                                                <label className='me-2'>{intl.formatMessage({ id: 'embedModalAsLink' })}</label>
                                                <div className="select-wrapper">
                                                    <select
                                                        id="showText"
                                                        value={linkShowAsLink}
                                                        onChange={(e) => this.setState({ linkShowAsLink: e.target.value })}
                                                    >
                                                        <option value="si">{intl_si}</option>
                                                        <option value="no">{intl_no}</option>
                                                    </select>
                                                </div>
                                                <label className='me-2'>{intl.formatMessage({ id: 'embedModalStyle' })}</label>
                                                <div className="select-wrapper">
                                                    <select
                                                        id="style"
                                                        value={linkStyle}
                                                        onChange={(e) => this.setState({ linkStyle: e.target.value })}
                                                    >
                                                        <option value="default">Default</option>
                                                        <option value="nostyle">Nessuno</option>
                                                    </select>
                                                </div>
                                                <label className='me-2'>{intl.formatMessage({ id: 'embedModalCompact' })}</label>
                                                <div className="select-wrapper">
                                                    <select
                                                        id="compact"
                                                        value={linkCompact}
                                                        onChange={(e) => this.setState({ linkCompact: e.target.value })}
                                                    >
                                                        <option value="si">{intl_si}</option>
                                                        <option value="no">{intl_no}</option>
                                                    </select>
                                                </div>
                                                <div className='d-flex justify-content-center mt-3 mb-0 pb-0'>
                                                    <textarea id="generatedLink" value={linkValue} readOnly={true}></textarea>
                                                    <ClipboardButton text={linkValue} toastify={toastify} />
                                                </div>
                                                <div>
                                                    <p className="discreet pt-2">
                                                        {intl.formatMessage({ id: 'embedModalDesc1' })}
                                                        <br />
                                                        {intl.formatMessage({ id: 'embedModalDesc2' })}
                                                        <br />
                                                        {intl.formatMessage({ id: 'embedModalDesc3' })}
                                                        <br />
                                                        {intl.formatMessage({ id: 'embedModalDesc4' })}
                                                        &nbsp;
                                                        <a target="_istruzioni" href="https://static.ict.uniba.it/uniba.widgets/rubrica/">{intl.formatMessage({ id: 'embedModalDesc5' })}</a>
                                                        <br />
                                                    </p>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </ModalBody>
                            </Modal>
                        ) : null}
                    </div>
                </div>
            </>
        );
    }
}

SchedaPersonaSimpleView.propTypes = {
    // Data
    props: PropTypes.object.isRequired,
    toastify: PropTypes.object,
    onClose: PropTypes.func,
    showViewLink: PropTypes.bool,

    // Routing / Internazionalizzazione
    intl: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,

    // Redux store
    personaOggReducer: PropTypes.object,
    personaQRCodeReducer: PropTypes.object,
    userSession: PropTypes.object,
    userResult: PropTypes.object,

    // Action creators
    getPersonaOgg: PropTypes.func.isRequired,
    getPersonaQRCode: PropTypes.func.isRequired,
};

SchedaPersonaSimpleView.defaultProps = {
    showViewLink: true,
};

export default injectLazyLibs(['toastify'])(
    connect(
        (state) => ({
            personaOggReducer: state.personaOggReducer,
            personaQRCodeReducer: state.personaQRCodeReducer,
            userSession: state.userSession,
            userResult: state.users.user,
        }),
        (dispatch) =>
            bindActionCreators(
                {
                    getPersonaOgg,
                    getPersonaQRCode,
                },
                dispatch
            )
    )(injectIntl(withRouter(SchedaPersonaSimpleView)))
);